/* eslint-disable quotes */
import { styled } from '@mui/material';

export const BpIcon = styled('span')(({ theme }) => ({
	borderRadius: 4,
	width: 17,
	height: 17,
	boxShadow: 'none',
	backgroundColor: '#FFFFFF 0% 0% no-repeat padding-box',
	border: '1px solid #C9C9C9',
	'input:hover ~ &': {
		backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
	},
	'input:disabled ~ &': {
		boxShadow: 'none',
		background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
	},
}));

export const BpCheckedIcon = styled(BpIcon)({
	backgroundColor: '#2682E7',
	backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
	'&::before': {
		display: 'flex',
		width: 17,
		height: 17,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundImage:
			"url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
		content: '""',
	},
	'input:hover ~ &': {
		backgroundColor: '#2682E7',
	},
	'input:disabled ~ &': {
		background: '#2682E7',
	},
});

export const BpRadioIcon = styled('span')(({ theme }) => ({
	borderRadius: '50%',
	width: 23,
	height: 23,
	boxShadow: 'inset 0 0 0 1px #C3C3C3, inset 0 -1px 0 #C3C3C3',
	backgroundColor: '#FFFFFF',
	backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
	'.Mui-focusVisible &': {
		outline: '2px auto rgba(19,124,189,.6)',
		outlineOffset: 2,
	},
	'input:hover ~ &': {
		backgroundColor: '#ebf1f5',
		...(theme.palette.mode === 'dark' && {
			backgroundColor: '#30404d',
		}),
	},
	'input:disabled ~ &': {
		boxShadow: 'none',
		background: 'rgba(206,217,224,.5)',
		...(theme.palette.mode === 'dark' && {
			background: 'rgba(57,75,89,.5)',
		}),
	},
}));

export const BpCheckedRadioIcon = styled('span')({
	borderRadius: '50%',
	width: 23,
	height: 23,
	boxShadow: 'inset 0 0 0 1px #0467D2, inset 0 -1px 0 #0467D2',
	backgroundColor: '#FFFFFF',
	'&::before': {
		display: 'block',
		width: 23,
		height: 23,
		backgroundImage: 'radial-gradient(#0467D2,#0467D2 50%,transparent 55%)',
		content: '""',
	},
});
